import { useState } from 'react'
import Button from '../../../Components/Button'
import useModalAccessibility from '../hooks/useModalAccessibility'

export default function NotesModal({ notes, onSave, onClose }) {
  const [localNotes, setLocalNotes] = useState(notes || '')
  const { dialogRef, isVisible, handleClose } = useModalAccessibility({
    onClose,
    initialFocusSelector: 'textarea'
  })

  const handleSave = () => {
    onSave(localNotes)
    handleClose()
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center"
      role="dialog"
      aria-modal="true"
      aria-label="Add a note"
      ref={dialogRef}
    >
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={handleClose}
        aria-hidden="true"
      />

      {/* Modal */}
      <div className={`relative bg-white rounded-t-2xl w-full max-w-lg transition-transform duration-300 ease-out ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}>
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 id="notes-modal-title" className="text-xl font-bold text-gray-900">Add a Note</h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600 text-2xl leading-none focus:outline-none focus:ring-2 focus:ring-sky-500 rounded"
            aria-label="Close notes"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-4">
          <label htmlFor="customer-notes" className="block text-gray-700 text-sm font-medium mb-2">
            Special Requests or Dietary Requirements
          </label>
          <textarea
            id="customer-notes"
            value={localNotes}
            onChange={(e) => setLocalNotes(e.target.value)}
            placeholder="E.g., no onions, gluten allergy, extra sauce..."
            maxLength={500}
            rows={4}
            aria-describedby="notes-char-count"
            className="w-full px-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-transparent text-gray-900 resize-none"
          />
          <p id="notes-char-count" className="mt-1 text-xs text-gray-500">
            {localNotes.length}/500 characters
          </p>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t bg-gray-50">
          <Button
            onClick={handleSave}
            variant="primary"
            theme="dark"
            size="lg"
            fullWidth
          >
            Save Note
          </Button>
        </div>
      </div>
    </div>
  )
}
